import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { MarkdownSerializerState as PMMarkdownSerializerState } from '@atlaskit/editor-prosemirror/markdown';
import { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import tableNodes from './tableSerializer';
import { getOrderFromMaybeOrderedListNode } from './utils/list';
import { escapeMarkdown, stringRepeat } from './utils/utils';
/**
 * Look for series of backticks in a string, find length of the longest one, then
 * generate a backtick chain of a length longer by one. This is the only proven way
 * to escape backticks inside code block and inline code (for python-markdown)
 */
export var generateOuterBacktickChain = function () {
  function getMaxLength(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var matches = text.match(/`+/g) || [];
    return matches.reduce(function (prev, val) {
      return val.length > prev.length ? val : prev;
    }, '').length;
  }
  return function (text) {
    var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var length = Math.max(minLength, getMaxLength(text) + 1);
    return stringRepeat('`', length);
  };
}();

/**
 * This is a map where the key is the node type name and the value is the attributes of the node.
 *
 * The nodes are rendered with an id attribute so that we can reference them in the markdown document.
 *
 * When converting back from markdown to prosemirror, we use the id to reapply the attributes to the node.
 */

export var MarkdownSerializerState = /*#__PURE__*/function (_PMMarkdownSerializer) {
  function MarkdownSerializerState(featureToggles, mentionMap, idMap) {
    var _this;
    _classCallCheck(this, MarkdownSerializerState);
    // @ts-ignore-next-line
    _this = _callSuper(this, MarkdownSerializerState, [nodes, marks, {}]);
    // ignoring as generated types for node serializer is inaccurate
    // parent and index in node serializers should be optional
    // Typing this as a string -- to override the PMMarkdownSerializerState type of any
    // In the confluence build -- this results in the out property being set to undefined in the constructor
    // whereas in the dev server this is stripped when the code is transpiled.
    // When it is used in transpilation -- "undefined" is added to the start of the generated text
    // out: string;
    _defineProperty(_this, "idMap", {});
    _defineProperty(_this, "idCounter", 0);
    _defineProperty(_this, "featureToggles", {});
    _defineProperty(_this, "mentionMap", {});
    /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */
    _defineProperty(_this, "delim", '');
    _defineProperty(_this, "out", '');
    _defineProperty(_this, "closed", null);
    /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */
    _defineProperty(_this, "fallbackState", {});
    _defineProperty(_this, "context", {
      insideTable: false
    });
    _this.nodes = nodes;
    _this.marks = marks;
    _this.featureToggles = featureToggles || {};
    _this.mentionMap = mentionMap || {};
    _this.idMap = idMap || {};
    _this.idCounter = Object.keys(_this.idMap).length;
    return _this;
  }

  /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */
  _inherits(MarkdownSerializerState, _PMMarkdownSerializer);
  return _createClass(MarkdownSerializerState, [{
    key: "findStateIdMap",
    value: function findStateIdMap(state, targetType, targetAttributes) {
      // eslint-disable-next-line guard-for-in
      for (var _key in state.idMap) {
        var _state$idMap$_key = state.idMap[_key],
          type = _state$idMap$_key.type,
          attributes = _state$idMap$_key.attributes;

        // Check type first for early exit
        if (type !== targetType) {
          continue;
        }

        // Check if attributes match
        var attributesMatch = true;
        for (var attrKey in targetAttributes) {
          // localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
          if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
            attributesMatch = false;
            break; // No need to check other attributes
          }
        }
        if (attributesMatch) {
          return _key;
        }
      }
      return null;
    }

    /**
     *
     * @param state: MarkdownSerializerState
     * @param type: string
     * @param attributes: Record<string, unknown>
     * @returns `id-[id]idMap` if the id is not found in the state
     */
  }, {
    key: "getIdBasedOnIdMap",
    value: function getIdBasedOnIdMap(state, type, attributes) {
      var id = state.findStateIdMap(state, type, attributes);
      if (id) {
        return id;
      }
      return "id-".concat(state.idCounter++);
    }
  }, {
    key: "updateFallbackState",
    value: function updateFallbackState(error, child) {
      if (error instanceof Error) {
        var _this$fallbackState;
        var childTypeName = child.type.name;
        var errorMessage = error.message;
        var childFallbackState = (_this$fallbackState = this.fallbackState) === null || _this$fallbackState === void 0 ? void 0 : _this$fallbackState[childTypeName];
        Object.assign(this.fallbackState, _defineProperty({}, childTypeName, _objectSpread(_objectSpread({}, childFallbackState), {}, _defineProperty({}, errorMessage, ((childFallbackState === null || childFallbackState === void 0 ? void 0 : childFallbackState[errorMessage]) || 0) + 1))));
      } else {
        throw error;
      }
    }

    /**
     * Defines the internal atBlank method used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
     */
  }, {
    key: "atBlank",
    value: function atBlank() {
      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      return /(^|\n)$/.test(this.out);
    }

    /**
     * Defines the internal flushClose method used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
     */
  }, {
    key: "flushClose",
    value: function flushClose() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      if (this.closed) {
        if (!this.atBlank()) {
          this.out += '\n';
        }
        if (size > 1) {
          var delimMin = this.delim;
          // Ignored via go/ees005
          // eslint-disable-next-line require-unicode-regexp
          var trim = /\s+$/.exec(delimMin);
          if (trim) {
            delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
          }
          for (var i = 1; i < size; i++) {
            this.out += delimMin + '\n';
          }
        }
        this.closed = null;
      }
    }

    /**
     * This method overide adds support for "options"
     * options is an object that can be used to pass additional information to the node serializer
     *
     * This is useful when a grandparent node has information that needs to be passed to a grandchild node
     *
     * For example, a table node has information about whether or not the table has a header row
     * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
     * @see MarkdownSerializerState.render()
     */
  }, {
    key: "render",
    value: function render(node, parent, index, options) {
      if (!this.nodes[node.type.name]) {
        throw new Error("Token type `".concat(node.type.name, "` not supported by Markdown renderer"));
      }
      if (options !== null && options !== void 0 && options.skipFallback) {
        this.nodes[node.type.name].serialize({
          state: this,
          node: node,
          parent: parent,
          index: index,
          options: options
        });
      } else {
        try {
          this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
          });
        } catch (error) {
          this.updateFallbackState(error, node);
          return this.nodes.fallback.serialize({
            state: this,
            node: node,
            parent: parent,
            index: index
          });
        }
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent(parent) {
      var _this2 = this;
      parent.forEach(function (child, _offset, index) {
        if (
        // If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
        child.isTextblock && !child.textContent &&
        // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
        !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) {
          return _this2.nodes.empty_line.serialize({
            state: _this2,
            node: child,
            parent: parent,
            index: index
          });
        }
        try {
          return _this2.render(child, parent, index);
        } catch (error) {
          _this2.updateFallbackState(error, child);
          return _this2.nodes.fallback.serialize({
            state: _this2,
            node: child,
            parent: parent,
            index: index
          });
        }
      });
    }

    /**
     * This method override will properly escape backticks in text nodes with "code" mark enabled.
     * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
     * inside a backtick fence.
     *
     * @see MarkdownSerializerState.renderInline()
     */
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "renderInline",
    value: function renderInline(parent, options) {
      var _this3 = this;
      var active = [];
      var trailing = '';

      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var progress = function progress(node, _, index) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var marks = node ? node.marks.filter(function (mark) {
          return _this3.marks[mark.type.name];
        }) : [];
        var leading = trailing;
        trailing = '';
        // If whitespace has to be expelled from the node, adjust
        // leading and trailing accordingly.
        if (node && node.isText && marks.some(function (mark) {
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          var info = _this3.marks[mark.type.name];
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return info && info.expelEnclosingWhitespace;
        })) {
          // Ignored via go/ees005
          // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
          var _ref = /^(\s*)(.*?)(\s*)$/m.exec(node.text),
            _ref2 = _slicedToArray(_ref, 4),
            lead = _ref2[1],
            inner = _ref2[2],
            trail = _ref2[3];
          leading += lead;
          trailing = trail;
          if (lead || trail) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node = inner ? node.withText(inner) : null;
            if (!node) {
              marks = active;
            }
          }
        }
        var code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
        var len = marks.length - (code ? 1 : 0);

        // Try to reorder 'mixable' marks, such as em and strong, which
        // in Markdown may be opened and closed in different order, so
        // that order of the marks for the token matches the order in
        // active.
        // eslint-disable-next-line no-labels
        outer: for (var i = 0; i < len; i++) {
          var mark = marks[i];
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if (!_this3.marks[mark.type.name].mixable) {
            break;
          }
          for (var j = 0; j < active.length; j++) {
            var other = active[j];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (!_this3.marks[other.type.name].mixable) {
              break;
            }
            if (mark.eq(other)) {
              if (i > j) {
                marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
              } else if (j > i) {
                marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
              }
              // eslint-disable-next-line no-labels
              continue outer;
            }
          }
        }

        // Find the prefix of the mark set that didn't change
        var keep = 0;
        while (keep < Math.min(active.length, len) && marks[keep].eq(active[keep])) {
          ++keep;
        }

        // Close the marks that need to be closed
        while (keep < active.length) {
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          _this3.text(_this3.markString(active.pop(), false, parent, index), false);
        }

        // Output any previously expelled trailing whitespace outside the marks
        if (leading) {
          _this3.text(leading);
        }

        // Open the marks that need to be opened
        while (active.length < len) {
          var add = marks[active.length];
          active.push(add);
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          _this3.text(_this3.markString(add, true, parent, index), false);
        }
        if (node) {
          if (!code || !node.isText) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            _this3.render(node, parent, index);
          } else if (node.text) {
            // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
            var text = node.text;
            var backticks = generateOuterBacktickChain(node.text, 1);

            // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (text.match(/^`/)) {
              text = ' ' + text;
            }

            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (text.match(/`$/)) {
              text += ' ';
            }
            _this3.text(backticks + text + backticks, false);
          }
        }
      };
      parent.forEach(function (child, _offset, index) {
        if (options !== null && options !== void 0 && options.skipFallback) {
          progress(child, parent, index);
        } else {
          try {
            progress(child, parent, index);
          } catch (error) {
            _this3.updateFallbackState(error, child);
          }
        }
      });
      progress(null);
    }
  }, {
    key: "addBlockMarks",
    value: function addBlockMarks(state, node, renderFunction) {
      var closingTags = [];
      // This is temporary, only adding the marks that we support, once we get full support this will be removed
      var markFilters = ['alignment', 'breakout', 'border'];
      var marks = node.marks.filter(function (mark) {
        return markFilters.includes(mark.type.name);
      });
      if (marks.length === 0) {
        renderFunction();
        return;
      }
      marks.forEach(function (mark) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: mark.type.name,
          attributes: mark.attrs
        };
        state.write("<custom data-type=\"".concat(mark.type.name, "_open\" data-id=\"").concat(id, "\" />\n\n"));
        closingTags.unshift("<custom data-type=\"".concat(mark.type.name, "_close\" />\n\n"));
      });
      renderFunction();
      state.write(closingTags.join(''));
    }
  }]);
}(PMMarkdownSerializerState);
var editorNodes = {
  blockquote: {
    serialize: function serialize(_ref3) {
      var state = _ref3.state,
        node = _ref3.node;
      state.wrapBlock('> ', null, node, function () {
        return state.renderContent(node);
      });
    },
    support: 'full'
  },
  codeBlock: {
    serialize: function serialize(_ref4) {
      var state = _ref4.state,
        node = _ref4.node;
      var backticks = generateOuterBacktickChain(node.textContent, 3);
      state.write(backticks + (node.attrs.language || '') + '\n');
      state.text(node.textContent ? node.textContent : "\u200C", false);
      state.ensureNewLine();
      state.write(backticks);
      state.closeBlock(node);
    },
    support: 'full'
  },
  heading: {
    serialize: function serialize(_ref5) {
      var state = _ref5.state,
        node = _ref5.node;
      state.write(state.repeat('#', node.attrs.level) + ' ');
      state.renderInline(node);
      state.closeBlock(node);
    },
    support: 'full'
  },
  rule: {
    serialize: function serialize(_ref6) {
      var state = _ref6.state,
        node = _ref6.node;
      state.write(node.attrs.markup || '---');
      state.closeBlock(node);
    },
    support: 'full'
  },
  bulletList: {
    serialize: function serialize(_ref7) {
      var state = _ref7.state,
        node = _ref7.node;
      for (var i = 0; i < node.childCount; i++) {
        var child = node.child(i);
        state.render(child, node, i);
      }
    },
    support: 'full'
  },
  orderedList: {
    serialize: function serialize(_ref8) {
      var state = _ref8.state,
        node = _ref8.node;
      for (var i = 0; i < node.childCount; i++) {
        var child = node.child(i);
        state.render(child, node, i);
      }
    },
    support: 'full'
  },
  listItem: {
    serialize: function serialize(_ref9) {
      var state = _ref9.state,
        node = _ref9.node,
        parent = _ref9.parent,
        index = _ref9.index;
      var order = getOrderFromMaybeOrderedListNode(parent);
      var delimiter = parent.type.name === 'bulletList' ? '* ' : "".concat(order + index, ". ");
      var _loop = function _loop(i) {
        var child = node.child(i);
        // if at second child or more of list item, add a newline
        if (i > 0) {
          state.write('\n');
        }
        // if at first child of list item, add delimiter (e.g "1.").
        // if at second child or more of list item, only add spacing (not delimiter)
        if (i === 0) {
          state.wrapBlock('  ', delimiter, node, function () {
            return state.render(child, parent, i);
          });
        } else {
          state.wrapBlock('    ', null, node, function () {
            return state.render(child, parent, i);
          });
        }
        if (child.type.name === 'paragraph' && i > 0) {
          state.write('\n');
        }
        state.flushClose(1);
      };
      for (var i = 0; i < node.childCount; i++) {
        _loop(i);
      }
      // if we're at the final list item, add a final closing newline
      if (index === parent.childCount - 1) {
        state.write('\n');
      }
    },
    support: 'full'
  },
  taskList: {
    serialize: function serialize(_ref10) {
      var state = _ref10.state,
        node = _ref10.node;
      for (var i = 0; i < node.childCount; i++) {
        var child = node.child(i);
        state.render(child, node, i);
        state.write('\n');
      }
      state.write('\n');
    },
    support: 'full'
  },
  taskItem: {
    serialize: function serialize(_ref11) {
      var state = _ref11.state,
        node = _ref11.node;
      var taskItemState = node.attrs.state;
      state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
      state.renderInline(node);
    },
    support: 'full'
  },
  paragraph: {
    serialize: function serialize(_ref12) {
      var state = _ref12.state,
        node = _ref12.node;
      state.renderInline(node);
      state.closeBlock(node);
    },
    support: 'full'
  },
  mediaGroup: {
    serialize: function serialize(_ref13) {
      var state = _ref13.state,
        node = _ref13.node;
      for (var i = 0; i < node.childCount; i++) {
        var child = node.child(i);
        state.render(child, node, i);
      }
    },
    support: 'fallback'
  },
  mediaInline: {
    serialize: function serialize(_ref14) {
      var state = _ref14.state,
        node = _ref14.node;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        state.addBlockMarks(state, node, function () {
          var id = "id-".concat(state.idCounter++);
          state.idMap[id] = {
            type: 'mediaInline',
            attributes: node.attrs
          };
          state.write("<custom data-type=\"mediaInline\" data-id=\"".concat(id, "\"></custom>"));
        });
      }
    },
    support: 'preview'
  },
  mediaSingle: {
    serialize: function serialize(_ref15) {
      var state = _ref15.state,
        node = _ref15.node,
        parent = _ref15.parent,
        index = _ref15.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        state.addBlockMarks(state, node, function () {
          var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : "id-".concat(state.idCounter++);
          state.idMap[id] = {
            type: 'mediaSingle',
            attributes: node.attrs
          };
          state.write("<custom data-type=\"media_single_open\" data-id=\"".concat(id, "\" />\n\n"));
          node.content.forEach(function (child, i) {
            try {
              state.render(child, node, i, {
                skipFallback: true
              });
            } catch (error) {
              state.updateFallbackState(error, node);
              state.nodes.fallback.serialize({
                state: state,
                node: node,
                parent: parent,
                index: index
              });
            }
          });
          state.write("<custom data-type=\"media_single_close\" />\n\n");
        });
      } else {
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          state.render(child, node, i);
        }

        /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */
        if (parent instanceof PMNode) {
          state.write('\n');
        } else {
          state.write('\n\n');
        }
      }
    },
    support: 'preview'
  },
  caption: {
    serialize: function serialize(_ref16) {
      var state = _ref16.state,
        node = _ref16.node,
        parent = _ref16.parent,
        index = _ref16.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'caption',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"caption_open\" data-id=\"".concat(id, "\" />\n\n"));
        try {
          state.renderInline(node, {
            skipFallback: true
          });
        } catch (error) {
          state.updateFallbackState(error, node);
          state.nodes.fallback.serialize({
            state: state,
            node: node,
            parent: parent,
            index: index
          });
        }

        // captions do not contain paragraphs, so we need to add a newline after the content
        state.write("\n\n<custom data-type=\"caption_close\" />\n\n");
      } else {
        state.write(node.textContent);
      }
    },
    support: 'preview'
  },
  media: {
    serialize: function serialize(_ref17) {
      var state = _ref17.state,
        node = _ref17.node;
      // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
      // Which allows image retention when using rovo since it doesn't support markdown plus
      var baseUrl = 'blob:https://atlassianinternalmedia.com/?';
      var queryString = Object.entries(node.attrs).map(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
          key = _ref19[0],
          value = _ref19[1];
        return key !== 'alt' ? "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)) : "";
      }).join('&');
      var fakeUrl = "".concat(baseUrl).concat(queryString);
      state.write("![](".concat(fakeUrl, ")").concat(state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''));
    },
    support: 'full'
  },
  image: {
    serialize: function serialize(_ref20) {
      var state = _ref20.state,
        node = _ref20.node;
      // Note: the 'title' is not escaped in this flavor of markdown.
      state.write('![' + escapeMarkdown(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? " '".concat(escapeMarkdown(node.attrs.title), "'") : '') + ')');
    },
    support: 'full'
  },
  hardBreak: {
    serialize: function serialize(_ref21) {
      var state = _ref21.state;
      state.write('  \n');
    },
    support: 'full'
  },
  text: {
    serialize: function serialize(_ref22) {
      var state = _ref22.state,
        node = _ref22.node,
        parent = _ref22.parent,
        index = _ref22.index;
      var previousNode = index === 0 ? null : parent.child(index - 1);
      var text = node.textContent;

      // BB converts 4 spaces at the beginning of the line to code block
      // that's why we escape 4 spaces with zero-width-non-joiner
      var fourSpaces = '    ';
      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      if (!previousNode && /^\s{4}/.test(node.textContent)) {
        text = node.textContent.replace(fourSpaces, "\u200C" + fourSpaces);
      }
      var lines = text.split('\n');
      for (var i = 0; i < lines.length; i++) {
        var startOfLine = state.atBlank() || !!state.closed;
        state.write();
        state.out += escapeMarkdown(lines[i], startOfLine, state.context.insideTable);
        if (i !== lines.length - 1) {
          if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) {
            state.out += '  ';
          }
          state.out += '\n';
        }
      }
    },
    support: 'full'
  },
  empty_line: {
    serialize: function serialize(_ref23) {
      var state = _ref23.state,
        node = _ref23.node;
      state.write("\u200C"); // zero-width-non-joiner
      state.closeBlock(node);
    },
    support: 'full'
  },
  placeholder: {
    serialize: function serialize(_ref24) {
      var state = _ref24.state,
        node = _ref24.node;
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'placeholder',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"placeholder\" data-id=\"".concat(id, "\">").concat(node.attrs.text, "</custom>"));
      }
    },
    support: 'custom'
  },
  mention: {
    serialize: function serialize(_ref25) {
      var state = _ref25.state,
        node = _ref25.node,
        parent = _ref25.parent,
        index = _ref25.index;
      var isLastNode = parent.childCount === index + 1;
      var delimiter = '';
      if (!isLastNode) {
        var nextNode = parent.child(index + 1);
        var nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
        delimiter = nextNodeHasLeadingSpace ? '' : ' ';
      }

      // Get the name from the map
      var name = state.mentionMap[node.attrs.id] || '';
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', _objectSpread(_objectSpread({}, node.attrs), {}, {
          text: "@".concat(name)
        })) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'mention',
          // Update the attributes to include resolved name
          attributes: _objectSpread(_objectSpread({}, node.attrs), {}, {
            text: "@".concat(name)
          })
        };
        if (state.featureToggles.markdownPlusAttributeTest) {
          // @ts-expect-error
          node.attrs.text = "@".concat(name);
          state.write("<custom data-type=\"mention\" data-id=\"".concat(id, "\" data-attrs=\"").concat(JSON.stringify(node.attrs), "\">@").concat(name, "</custom>"));
        } else {
          state.write("<custom data-type=\"mention\" data-id=\"".concat(id, "\">@").concat(name, "</custom>"));
        }
      } else {
        state.write("".concat(name).concat(delimiter));
      }
    },
    support: 'custom'
  },
  date: {
    serialize: function serialize(_ref26) {
      var state = _ref26.state,
        node = _ref26.node;
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'date',
          attributes: node.attrs
        };
        if (state.featureToggles.markdownPlusAttributeTest) {
          state.write("<custom data-type=\"date\" data-id=\"".concat(id, "\" data-attrs=\"").concat(JSON.stringify(node.attrs), "\">").concat(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)), "</custom>"));
        } else {
          state.write("<custom data-type=\"date\" data-id=\"".concat(id, "\">").concat(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)), "</custom>"));
        }
      } else {
        state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
      }
    },
    support: 'custom'
  },
  emoji: {
    serialize: function serialize(_ref27) {
      var state = _ref27.state,
        node = _ref27.node;
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'emoji',
          attributes: node.attrs
        };
        if (state.featureToggles.markdownPlusAttributeTest) {
          state.write("<custom data-type=\"emoji\" data-id=\"".concat(id, "\" data-attrs=\"").concat(JSON.stringify(node.attrs), "\">").concat(node.attrs.shortName, "</custom>"));
        } else {
          state.write("<custom data-type=\"emoji\" data-id=\"".concat(id, "\">").concat(node.attrs.shortName, "</custom>"));
        }
      } else {
        state.write(node.attrs.shortName);
      }
    },
    support: 'custom'
  },
  inlineCard: {
    serialize: function serialize(_ref28) {
      var state = _ref28.state,
        node = _ref28.node;
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'inlineCard',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"smartlink\" data-id=\"".concat(id, "\">").concat(node.attrs.url, "</custom>"));
      } else {
        state.write("[".concat(node.attrs.url, "](").concat(node.attrs.url, ")"));
      }
    },
    support: 'custom'
  },
  status: {
    serialize: function serialize(_ref29) {
      var state = _ref29.state,
        node = _ref29.node;
      if (state.featureToggles.markdownPlus) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'status',
          attributes: node.attrs
        };
        if (state.featureToggles.markdownPlusAttributeTest) {
          state.write("<custom data-type=\"status\" data-id=\"".concat(id, "\" data-attrs=\"").concat(JSON.stringify(node.attrs), "\">").concat(node.attrs.text, "</custom>"));
        } else {
          state.write("<custom data-type=\"status\" data-id=\"".concat(id, "\">").concat(node.attrs.text, "</custom>"));
        }
      } else {
        // this will trigger the fallback conversion (text)
        throw new Error('Token type `status` not supported by Markdown renderer');
      }
    },
    support: 'custom'
  },
  layoutSection: {
    serialize: function serialize(_ref30) {
      var state = _ref30.state,
        node = _ref30.node,
        parent = _ref30.parent,
        index = _ref30.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        state.addBlockMarks(state, node, function () {
          var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : "id-".concat(state.idCounter++);
          state.idMap[id] = {
            type: 'layoutSection',
            attributes: node.attrs
          };
          state.write("<custom data-type=\"layoutSection_open\" data-id=\"".concat(id, "\" />\n\n"));
          for (var i = 0; i < node.childCount; i++) {
            var child = node.child(i);
            try {
              state.render(child, node, i, {
                skipFallback: true
              });
            } catch (error) {
              state.updateFallbackState(error, node);
              state.nodes.fallback.serialize({
                state: state,
                node: node,
                parent: parent,
                index: index
              });
            }
          }
          state.write("<custom data-type=\"layoutSection_close\" />\n\n");
        });
      } else {
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          state.render(child, node, i);
        }
      }
    },
    support: 'preview'
  },
  layoutColumn: {
    serialize: function serialize(_ref31) {
      var state = _ref31.state,
        node = _ref31.node,
        parent = _ref31.parent,
        index = _ref31.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'layoutColumn',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"layoutColumn_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        }
        state.write("<custom data-type=\"layoutColumn_close\" />\n\n");
      } else {
        for (var _i = 0; _i < node.childCount; _i++) {
          var _child = node.child(_i);
          state.render(_child, node, _i);
        }
      }
    },
    support: 'preview'
  },
  expand: {
    serialize: function serialize(_ref32) {
      var state = _ref32.state,
        node = _ref32.node,
        parent = _ref32.parent,
        index = _ref32.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        state.addBlockMarks(state, node, function () {
          var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : "id-".concat(state.idCounter++);
          state.idMap[id] = {
            type: 'expand',
            attributes: node.attrs
          };
          state.write("<custom data-type=\"expand_open\" data-id=\"".concat(id, "\" />\n\n"));
          for (var i = 0; i < node.childCount; i++) {
            var child = node.child(i);
            try {
              state.render(child, node, i, {
                skipFallback: true
              });
            } catch (error) {
              state.updateFallbackState(error, node);
              state.nodes.fallback.serialize({
                state: state,
                node: node,
                parent: parent,
                index: index
              });
            }
          }
          state.write("<custom data-type=\"expand_close\" />\n\n");
        });
      } else {
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          state.render(child, node, i);
        }
      }
    },
    support: 'preview'
  },
  nestedExpand: {
    serialize: function serialize(_ref33) {
      var state = _ref33.state,
        node = _ref33.node,
        parent = _ref33.parent,
        index = _ref33.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'nestedExpand',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"nestedExpand_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        }
        state.write("<custom data-type=\"nestedExpand_close\" />\n\n");
      } else {
        for (var _i2 = 0; _i2 < node.childCount; _i2++) {
          var _child2 = node.child(_i2);
          state.render(_child2, node, _i2);
        }
      }
    },
    support: 'preview'
  },
  panel: {
    serialize: function serialize(_ref34) {
      var state = _ref34.state,
        node = _ref34.node,
        parent = _ref34.parent,
        index = _ref34.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'panel',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"panel_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        }
        state.write("<custom data-type=\"panel_close\" />\n\n");
      } else {
        for (var _i3 = 0; _i3 < node.childCount; _i3++) {
          var _child3 = node.child(_i3);
          state.render(_child3, node, _i3);
        }
      }
    },
    support: 'custom'
  },
  blockCard: {
    serialize: function serialize(_ref35) {
      var state = _ref35.state,
        node = _ref35.node;
      state.write("[".concat(node.attrs.url, "](").concat(node.attrs.url, ")"));
    },
    support: 'full'
  },
  embedCard: {
    serialize: function serialize(_ref36) {
      var state = _ref36.state,
        node = _ref36.node;
      state.write("[".concat(node.attrs.url, "](").concat(node.attrs.url, ")"));
    },
    support: 'full'
  },
  decisionList: {
    serialize: function serialize(_ref37) {
      var state = _ref37.state,
        node = _ref37.node;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'decisionList',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"decisionList_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          state.render(child, node, i);
        }
        state.write("<custom data-type=\"decisionList_close\" />\n\n");
      } else {
        for (var _i4 = 0; _i4 < node.childCount; _i4++) {
          var _child4 = node.child(_i4);
          state.render(_child4, node, _i4);
        }
        state.write("\n\n");
      }
    },
    support: 'custom'
  },
  decisionItem: {
    serialize: function serialize(_ref38) {
      var state = _ref38.state,
        node = _ref38.node,
        parent = _ref38.parent,
        index = _ref38.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'decisionItem',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"decisionItem_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        }
        state.write("\n\n<custom data-type=\"decisionItem_close\" />\n\n");
      } else {
        for (var _i5 = 0; _i5 < node.childCount; _i5++) {
          var _child5 = node.child(_i5);
          state.render(_child5, node, _i5);
        }
      }
    },
    support: 'custom'
  },
  extension: {
    serialize: function serialize(_ref39) {
      var state = _ref39.state,
        node = _ref39.node;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'extension',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"extension\" data-id=\"".concat(id, "\" />\n\n"));
      }
    },
    support: 'custom'
  },
  inlineExtension: {
    serialize: function serialize(_ref40) {
      var state = _ref40.state,
        node = _ref40.node;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'inlineExtension',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"inlineExtension\" data-id=\"".concat(id, "\"></custom>"));
      }
    },
    support: 'custom'
  },
  bodiedExtension: {
    serialize: function serialize(_ref41) {
      var state = _ref41.state,
        node = _ref41.node,
        parent = _ref41.parent,
        index = _ref41.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'bodiedExtension',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"bodiedExtension_open\" data-id=\"".concat(id, "\" />\n\n"));
        for (var i = 0; i < node.childCount; i++) {
          var child = node.child(i);
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        }
        state.write("<custom data-type=\"bodiedExtension_close\" />\n\n");
      } else {
        for (var _i6 = 0; _i6 < node.childCount; _i6++) {
          var _child6 = node.child(_i6);
          state.render(_child6, node, _i6);
        }
      }
    },
    support: 'custom'
  },
  fallback: {
    serialize: function serialize(_ref42) {
      var state = _ref42.state,
        node = _ref42.node;
      // If PMNode is an unhandled block node, we need to add a newline
      // after the content to prevent the next line from being rendered as
      // part of the block node.

      if (node.isBlock) {
        state.write("".concat(node.textContent || node.attrs.text || '', "\n\n"));
      } else {
        state.write(node.textContent || node.attrs.text || '');
      }
    },
    support: 'fallback'
  }
};
export var nodes = _objectSpread(_objectSpread({}, editorNodes), tableNodes);
export var marks = {
  em: {
    open: '_',
    close: '_',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  strong: {
    open: '**',
    close: '**',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  strike: {
    open: '~~',
    close: '~~',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  link: {
    open: '[',
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    close: function close(_state, mark) {
      return '](' + mark.attrs['href'] + ')';
    }
  },
  code: {
    open: '`',
    close: '`'
  }
};